const guid = () => {
    const sFour = () => Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    return `${sFour() + sFour()}-${sFour()}-${sFour()}-${sFour()}-${sFour()}${sFour()}${sFour()}`;
};

export default guid;
